import { ConfigProvider } from 'antd-mobile';
import frFR from 'antd-mobile/es/locales/fr-FR';
import React from 'react';

import './App.css';
import { Main, Updater } from './components/features/app';
import ProvideNavbar from './hooks/use-navbar';
import AuthProvider from './hooks/use-auth';
// Import use-theme just for the side-effect of applying the saved
// theme class on document.body at module load time (avoids flash).
import './hooks/use-theme';
// Applique l'echelle de police enregistree (zoom global) avant le montage.
import './hooks/use-font-scale';

const App = (): React.JSX.Element => {
  return (
    <>
      <ConfigProvider locale={frFR}>
        <AuthProvider>
          <ProvideNavbar>
            <Main className="child-main" />
          </ProvideNavbar>
        </AuthProvider>
        <Updater />
      </ConfigProvider>
    </>
  );
};

export default App;
